import React from 'react';
import { Section } from './ui/Section';
const painPoints = ['Llegás a la clase sin saber exactamente qué elemento vas a trabajar hoy con cada grupo', 'Tus alumnos no progresan porque no tenés una secuencia clara de habilidades de un nivel al siguiente', 'El 40% de tus alumnos abandona antes de los 3 meses porque no ven avance y no sabés cómo prevenirlo', 'Siempre los mismos ejercicios de siempre porque no tenés más material técnico listo para usar', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible y documentado', 'Correcciones técnicas improvisadas en pista, sin un protocolo claro que te respalde ante los padres', 'Alumnos de distintas edades y niveles juntos y la clase se convierte en un caos difícil de manejar', 'Fin de mes y los alumnos se van sin avisar porque no ven progresión real en sus clases de patinaje'];
export function PainPoints() {
  return <Section className="bg-brand-ice/50" data-id="element-206">
      <div className="max-w-4xl mx-auto" data-id="element-207">
        <div className="text-center mb-6 md:mb-12" data-id="element-208">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 md:mb-6 text-brand-dark" data-id="element-209">
            Si sos profesor/a de patinaje artístico en Argentina, esto te va a
            sonar familiar:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-210">
          {painPoints.map((point, index) => <div key={index} className="flex items-start p-4 md:p-6 rounded-lg md:rounded-xl bg-brand-ice/60 border border-brand-iceDark hover:border-brand-accent/30 transition-colors" data-id="element-211">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-dark text-white flex items-center justify-center font-bold text-sm md:text-lg mr-3 md:mr-4" data-id="element-212">
                0{index + 1}
              </div>
              <p className="text-sm md:text-base text-brand-dark/70 leading-relaxed pt-0.5 md:pt-1" data-id="element-213">
                {point}
              </p>
            </div>)}
        </div>

        <div className="text-center bg-brand-ice/50 p-5 md:p-8 rounded-xl md:rounded-2xl border border-brand-iceDark" data-id="element-214">
          <h3 className="text-xl md:text-3xl font-serif font-bold text-brand-dark" data-id="element-215">
            ¿Cuántas clases más vas a improvisar
            <br className="hidden md:block" data-id="element-216" /> antes de tener un sistema real?
          </h3>
        </div>
      </div>
    </Section>;
}